import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import SendImg from "../images/Email Send.png";

function Chatbot() {
  const chatEndRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [sessionId, setSessionId] = useState("");

  const generateSessionId = () => {
    return `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  };

  useEffect(() => {
    let existingSessionId = sessionStorage.getItem("sessionId");
    if (!existingSessionId) {
      const newSessionId = generateSessionId();
      sessionStorage.setItem("sessionId", newSessionId);
      setSessionId(newSessionId);
    } else {
      setSessionId(existingSessionId);
    }

    const savedMessages = sessionStorage.getItem("chatMessages");
    if (savedMessages) {
      setMessages(JSON.parse(savedMessages));
    }
  }, []);

  useEffect(() => {
    if (sessionId) {
      handleSendMessage("hi", sessionId);
    }
  }, [sessionId]);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  const enrichResponseWithLinks = (text, posts) => {
    if (!posts || typeof posts !== "object") return text;

    // Sort post titles by length (descending) to match longer ones first
    const sortedEntries = Object.entries(posts).sort(
      ([a], [b]) => b.length - a.length
    );

    sortedEntries.forEach(([title, url]) => {
      // Escape all special characters in the title for safe regex matching
      const escapedTitle = title.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      const regex = new RegExp(escapedTitle, "g");

      text = text.replace(
        regex,
        `<a href="${url}" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">${title}</a>`
      );
    });

    return text;
  };
  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const handleSendMessage = async (
    defaultInput = null,
    session = sessionId
  ) => {
    let input = defaultInput;
    if (input && typeof input === "object" && input.target) {
      input = userInput; // Use userInput state instead
    }
    input = (input || userInput || "").toString();
    input = (defaultInput || userInput || "").toString();

    if (input.trim() === "") return;

    const updatedMessages = [...messages, { text: input, sender: "user" }];
    setMessages(updatedMessages);

    sessionStorage.setItem("chatMessages", JSON.stringify(updatedMessages));

    setIsTyping(true);

    const payload = {
      author_id: session,
      user_input: input,
    };

    setUserInput("");
    try {
      const response = await axios.post(
        "https://bvchatbot.brainvire.net/bvsite-chat/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const posts = response.data.data.posts || {};
      const enrichedText = enrichResponseWithLinks(
        response.data.data.response,
        posts
      );

      const botMessage = {
        text: enrichedText,
        sender: "bot",
        img_encoding: response.data.img_encoding || null,
        posts: posts,
      };
      const newMessages = [...updatedMessages, botMessage];
      setMessages(newMessages);
      sessionStorage.setItem("chatMessages", JSON.stringify(newMessages));
    } catch (error) {
      console.error("Error fetching data from API:", error);
    } finally {
      setIsTyping(false);
    }
  };

  const handleClearSession = () => {
    sessionStorage.clear();
    setMessages([]);
    const newSessionId = generateSessionId();
    sessionStorage.setItem("sessionId", newSessionId);
    setSessionId(newSessionId);
  };

  return (
    <>
      <nav className="navbar bg-white d-flex justify-content-center">
        <img
          href="/"
          className="navbar-brand"
          src={
            "https://www.brainvire.com/_next/image/?url=%2Fassets%2Fimages%2Fbrainvire-logo.svg&w=384&q=75"
          }
          alt="Logo"
        />
      </nav>
      <div
        className="main__app"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: messages.length === 0 ? "center" : "flex-end",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={8}>
              <Card style={{ border: "none" }}>
                <Card.Body
                  className={`${
                    messages.length === 0 ? "chat_card_noData" : "card_body"
                  }`}
                >
                  {messages.length !== 0 && !isTyping && (
                    <div className="chat-header d-flex justify-content-between">
                      <span>Let's Talk</span>
                      <span>
                        <i
                          className="fa-solid fa-rotate-right"
                          onClick={handleClearSession}
                          style={{ cursor: "pointer" }}
                        ></i>
                      </span>
                    </div>
                  )}
                  <div
                    className={`${
                      messages.length === 0 ? "chat_card_noData" : "chat_card"
                    }`}
                  >
                    {messages.map((msg, index) => (
                      <div
                        key={index}
                        className={`${
                          msg.sender === "user"
                            ? " d-flex mb-3 justify-content-end"
                            : "justify-content-start"
                        }`}
                      >
                        {msg.sender === "bot" && (
                          <div className="d-flex justify-content-start">
                            <p className="font-bold AI_Bot">AI Bot</p>
                          </div>
                        )}
                        {!(
                          index === 0 &&
                          msg.sender === "user" &&
                          msg.text.toLowerCase() === "hi"
                        ) && (
                          <div
                            className={`${
                              msg.sender === "user"
                                ? "user_text text-white mt-3"
                                : "user_replay"
                            }`}
                            style={{ maxWidth: "70%" }}
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: msg.text.replace(/\n/g, "<br />"),
                              }}
                            />

                            {/* If bot and posts exist, show the links here */}
                            {/* {msg.sender === "bot" &&
                              msg.posts &&
                              Object.keys(msg.posts).length > 0 && (
                                <>
                                  <p style={{ fontWeight: "bold", margin: 0 }}>
                                    Related Posts:
                                  </p>
                                  <ul
                                    style={{
                                      paddingLeft: "20px",
                                    }}
                                  >
                                    {Object.entries(msg.posts).map(
                                      ([title, url], idx) => (
                                        <li
                                          key={idx}
                                          style={{ marginBottom: 2 }}
                                        >
                                          <a
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {title}
                                          </a>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </>
                              )} */}
                          </div>
                        )}
                      </div>
                    ))}

                    {isTyping && (
                      <div className="d-flex mb-3 justify-content-start text-align-justify">
                        <div
                          className="user_replay"
                          style={{ maxWidth: "70%" }}
                        >
                          <div className="typing-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* <div ref={chatEndRef} />
                    {isFinal && (
                      <Button
                        className="mt-3"
                        variant="primary"
                        onClick={handleDownloadPDF}
                        style={{
                          backgroundColor: "#244BC5",
                        }}
                      >
                        Download Plan
                      </Button>
                    )} */}
                  </div>
                  <div className="form-container">
                    {messages.length === 0 && !isTyping && (
                      <h6>What can I help with?</h6>
                    )}
                    <Form className="d-flex mt-3">
                      <Form.Control
                        type="text"
                        className="textArea"
                        placeholder="Type your message here..."
                        value={userInput}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                      />
                      <img
                        src={SendImg}
                        alt="Send Message"
                        className="send_img1"
                        onClick={() => handleSendMessage()}
                        style={{
                          backgroundColor:
                            userInput.trim() === "" ? "#728de0" : "#244BC5",
                          cursor:
                            userInput.trim() === "" ? "not-allowed" : "pointer",
                        }}
                      />
                    </Form>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <footer className="footer">
        <p className="py-3">
          <small> © 2025 Brainvire Infotech. All rights reserved.</small>
        </p>
      </footer>
    </>
  );
}

export default Chatbot;
